import 'ts-helpers';
import './polyfills';

import { enableProdMode, importProvidersFrom, Injectable } from '@angular/core';
import { provideAnimations } from '@angular/platform-browser/animations';
import { GalleryModule } from '@ks89/angular-modal-gallery';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { LazyLoadImageModule } from 'ng-lazyload-image';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { ValidatorsModule } from 'ngx-validators';
import { NgxWigModule } from 'ngx-wig';
import { AppComponent } from './app/app.component';
import { Ng5BreadcrumbModule } from './app/shared/breadcrumb/breadcrumb.module';
import { oase_config } from './environments/environment';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { bootstrapApplication } from '@angular/platform-browser';
import {
	provideL10nTranslation,
	provideL10nValidation
} from 'angular-l10n';
import { DROPZONE_CONFIG, DropzoneConfigInterface, DropzoneModule } from 'ngx-dropzone-wrapper';
import { Observable } from 'rxjs';
import { routing } from './app/app.routing';
import { AuthModule } from './app/shared/auth.module';
import { CustomMatPaginatorIntl } from './app/shared/custom.matpaginatorintl';
import { DatePipe } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpEvent, HttpHandler, HttpInterceptor, HttpParams, HttpRequest, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { RouterModule } from "@angular/router";
import { JWT_OPTIONS, JwtModule } from "@auth0/angular-jwt";
import { APIConfigService } from './app/api.config.service';
import { RestServiceImpl } from './app/protected/immerdrin/rest.service.impl';
import { RestService } from './app/protected/immerdrin/rest.service.interface';
import { Data } from './app/providers/data';
import { AuthGuard } from './app/shared/auth.guard';
import { AuthService } from './app/shared/auth.service';
import { ErrorHelper } from './app/shared/error.helper';
import { JwtRefreshInterceptor } from './app/shared/jwtrefresh.interceptor';
import { LoggerService } from './app/shared/logger.service';
import { SessionService } from './app/shared/session.service';
import { WINDOW_PROVIDERS } from './app/window';
import { Ng2CsvService } from 'ng2csv';
import { AppStorage, HttpTranslationLoader, l10nConfig, LocaleValidation } from "./app/shared/l10n/l10n-config";

const REST_API_BILD: string =
	window.location.hostname === 'localhost' || window.location.hostname === oase_config.restapi.dev.host
		? oase_config.restapi.dev.schema + '://' + oase_config.restapi.dev.host + '/' + oase_config.restapi.dev.path + '/bild/hinzufuegen/'
		: oase_config.restapi.prod.schema + '://' + oase_config.restapi.prod.host + '/' + oase_config.restapi.prod.path + '/bild/hinzufuegen/';

const DEFAULT_DROPZONE_CONFIG: DropzoneConfigInterface = {
	// url: BILD_URL,
	url: REST_API_BILD,
	autoReset: 5000,
	errorReset: 5000,
	maxFilesize: 50,
	thumbnailWidth: 200, // Wird die Breite geändert muss auch das Style ".dropzone .dz-preview .dz-image" in override.scss geändert werden
	thumbnailHeight: 200, // Wird die Höhe geändert muss auch das Style ".dropzone .dz-preview .dz-image" in override.scss geändert werden
	autoProcessQueue: false, // Dateien NICHT automatisch hochladen
	createImageThumbnails: true
};

const PATH_FILE="main.ts";

@Injectable()
class CustomRequestOptions implements HttpInterceptor {
	intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		console.log(PATH_FILE+' - CustomRequestOptions intercept request.params: ', request.params);
		return next.handle(request.clone({ params: (request.params ? request.params : new HttpParams()).set('tsp', new Date().getTime().toString()) }));
	}
}

if (window.location.hostname != 'localhost') {
    console.log(PATH_FILE+' - environment.production');
    enableProdMode();
} else {
    console.log(PATH_FILE+' - NOT environment.production');
}

export function jwtOptionsFactory(apiConfigService: APIConfigService) {
	return {
		tokenGetter: () => {
			let token = localStorage.getItem(oase_config.auth_token.name);
			return token },
			allowedDomains: ['localhost:4200','lisweb.kaerntnermilch.at','liswebtest.kaerntnermilch.at']
	};
}

export function tokenGetter() {
	return localStorage.getItem('authtoken');
}


console.log(PATH_FILE+' - Running ' + oase_config.appversion + ' JIT compiled');
bootstrapApplication(AppComponent, {
    providers: [
        importProvidersFrom(
			FormsModule,
			ReactiveFormsModule,
			RouterModule,
			routing,
			AuthModule,
			DropzoneModule,
			Ng5BreadcrumbModule.forRoot(),
			FlexLayoutModule,
			GalleryModule,
			LazyLoadImageModule,
			ValidatorsModule,
        	NgxWigModule,
			NgxMatSelectSearchModule,
			JwtModule.forRoot({
				jwtOptionsProvider: {
					provide: JWT_OPTIONS,
					useFactory: jwtOptionsFactory,
					deps: [APIConfigService]
				}
			}),
			// RedirectComponent
			),
		{ provide: RestService, useClass: RestServiceImpl },
		{ provide: HTTP_INTERCEPTORS, useClass: JwtRefreshInterceptor, multi: true },
		{ provide: HTTP_INTERCEPTORS, useClass: CustomRequestOptions, multi: true },
		{ provide: DROPZONE_CONFIG, useValue: DEFAULT_DROPZONE_CONFIG },
		{ provide: MatPaginatorIntl, useClass: CustomMatPaginatorIntl }, // Mat-Paginator l10n
		provideL10nTranslation(
			l10nConfig,
			{
				storage: AppStorage,
				translationLoader: HttpTranslationLoader
			}
		),
		provideL10nValidation({ validation: LocaleValidation }),
		WINDOW_PROVIDERS,
		provideHttpClient(withInterceptorsFromDi()),
		provideAnimations(),
		APIConfigService,
		Ng2CsvService,
		AuthService,
		SessionService,
		LoggerService,
		RestServiceImpl,
		Data,
		JwtRefreshInterceptor,
		DatePipe,
		AuthGuard,
		ErrorHelper,
    ]
});
